/**
 * SecureIcon/index.js
 * desc: secure icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SecureIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="secure icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.secure.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg"><path d="M0 4l9-4 9 4v6c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V4zm16 6.99H9v-8.8L2 5.3V11h7v8.93c3.72-1.15 6.47-4.82 7-8.94z" /></svg>
    </IconButton>
);


export default SecureIcon;
